import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var De = function De(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M0 3.2h16v3.2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F01515",
    d: "M0 6.4h16v3.2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD521",
    d: "M0 9.6h16v3.2H0z"
  }));
};
export default De;